import { render, staticRenderFns } from "./AreaWeightsModal.vue?vue&type=template&id=6fece03c&scoped=true"
import script from "./AreaWeightsModal.vue?vue&type=script&lang=js"
export * from "./AreaWeightsModal.vue?vue&type=script&lang=js"
import style0 from "./AreaWeightsModal.vue?vue&type=style&index=0&id=6fece03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fece03c",
  null
  
)

export default component.exports